/**
 * Created by andrey on 26.12.2020.
 */

const EditorUnitView = UnitView.extend({
    ctor: function (unit, ...args) {
        this._super(unit, ...args);

        unit.onApplyShift = this.createListener(this.onApplyShift.bind(this));

        if (Map2d.currentMap.selection.isSelected(unit)) {
            unit.highlight();
        } else {
            unit.unhighlight();
        }
    },

    createAdditionalView: function (...args) {
        if (this.unit.chooser) {
            return;
        }
        this._super(...args);
    },

    onSceneSelected: function (options) {
        if (options.highlight || cleverapps.config.name === "wordsoup") {
            this.unit.highlight({ isErrorLight: false, drag: true });
        }
    },

    onSceneUnselected: function () {
        this.unit.unhighlight();
    },

    createComponentViews: function () {
        this.unit.components.forEach(function (component) {
            EditorViewFactory(component, this);
        }, this);
    },

    onApplyShift: function () {
        const multiple = this.unit.findComponent(Multiple);
        if (!multiple || !multiple.view) {
            return;
        }

        const pos = Map2d.currentMap.getMapView().alignInGrid(this.unit.x, this.unit.y);
        multiple.view.unitView.setPosition(pos.x, pos.y);
        multiple.view.applyShift();
    },

    handleDragStart: function (touch, ...rest) {
        this.dragOffset = cc.pSub(this, this.parent.convertToNodeSpace(touch.getStartLocation()));

        Map2d.currentMap.selection.iterate(this.unit, (unit, unitView) => {
            unit.draggingUnitOffset = cc.p(unitView.x - this.x, unitView.y - this.y);

            this._super.call(unitView, touch, ...rest);
        });

        return this._super(touch, ...rest);
    },

    handleFollowPointer: function (touch) {
        const pos = cc.pAdd(this.parent.convertToNodeSpace(touch.getLocation()), this.dragOffset);
        this.setAlignment(pos);

        Map2d.currentMap.selection.iterate(this.unit, (unit, unitView) => {
            unitView.setAlignment(cc.pAdd(pos, unit.draggingUnitOffset));
        });
    },

    handleDragMove: function (...args) {
        this._super(...args);

        Map2d.currentMap.selection.iterate(this.unit, (unit, unitView) => {
            this._super.call(unitView, ...args);
        });
    },

    handleDragEnd: function (cancelled, ...rest) {
        Map2d.currentMap.selection.checkErrors(this.unit);

        this._super(cancelled, ...rest);

        Map2d.currentMap.selection.iterate(this.unit, (unit, unitView) => {
            delete unit.draggingUnitOffset;
            this._super.call(unitView, cancelled, ...rest);
            unit.highlight();
        });

        if (Map2d.currentMap.selection.isSelected(this.unit)) {
            this.unit.highlight();
        }
    },

    onDeletePressed: function () {
        if (confirm(`Delete unit "${this.unit.code}'?`)) {
            Editor.currentEditor.doCommand("deleteUnit", { x: this.unit.x, y: this.unit.y, hash: this.unit.getUnitHash() });
        }
    }
});
